import './plot-detail-modal.scss';
import { h } from 'preact';
import { useRef, useEffect, useState } from 'preact/hooks';

import CloseButton from '../CloseButton';
import ImageGallery from './components/ImageGallery/ImageGallery';
import PlotProperties from './components/PlotProperties/PlotProperties';
import RegisterButton from './components/RegisterButton/RegisterButton';
import PlotDescription from './components/PlotDescription/PlotDescription';
import PlotDownloads from './components/PlotDownloads/PlotDownloads';

export default function PlotDetailModal({
	id,
	name,
	description,
	descriptionHtml,
	properties,
	images,
	documents,
	houseModel,
	registerLink,
	isActive,
	onCloseHandler,
	onFullScreenImageGalleryOpen
}) {
	const scrollContainer = useRef(null);
	const [plotImages, setImages] = useState([]);
	const [plotDocuments, setDocuments] = useState([]);

	useEffect(() => {
		if (scrollContainer.current && scrollContainer.current.nodeType === 1) {
			scrollContainer.current.scrollTop = 0;
		}
	}, [id]);

	useEffect(() => {
		setDocuments([].concat(...[documents, houseModel ? houseModel.documents : []].filter(documentToCheck => documentToCheck)));
	}, [documents, houseModel]);

	useEffect(() => {
		setImages([].concat(...[images || [], houseModel ? houseModel.images : []]));
	}, [images, houseModel]);

	return (
		<div
			class={`plot-detail-modal-container${isActive ? ' is-active' : ''}`}
			aria-hidden={!isActive}
			disabled={!isActive}
			tabIndex={!isActive ? '-1' : false}
		>
			<div class="plot-detail-modal-header-container">
				<h2 class="plot-detail-name">{name}</h2>
				<CloseButton onClickHandler={onCloseHandler} isDisabled={!isActive} />
			</div>
			<div ref={scrollContainer} class="plot-detail-modal-viewport-container">
				<div class="plot-detail-modal-viewport-container-inner">
					{Array.isArray(plotImages) && plotImages.length > 0 ?
						<ImageGallery images={plotImages} onFullScreenImageGalleryOpen={onFullScreenImageGalleryOpen} /> : ''}
					{properties && properties.length > 0 ?
						<PlotProperties properties={properties} /> : ''}
					{(description || descriptionHtml || houseModel?.description) &&
						<PlotDescription
							description={description}
							descriptionHtml={descriptionHtml || (!description && houseModel?.description)}
						/>}
					{Array.isArray(plotDocuments) && plotDocuments.length > 0 ?
						<PlotDownloads downloads={plotDocuments} /> : ''}
				</div>
			</div>
			{registerLink && registerLink.url ?
				<div class="plot-detail-modal-footer-container">
					<RegisterButton {...registerLink} plotNumberId={id} />
				</div> : ''}
		</div>
	);
}
